import { SET_DATA_KEY } from '../../constants'
import { isSetRestSetDataUtil } from '../is-set-rest'

const SET_DATA_REP_DURATION = 4

function getDurationFromRepsSetDataUtil (reps) {
  return reps * SET_DATA_REP_DURATION
}

function getSetDurationSetDataUtil (set) {
  if (!set) {
    return 0
  }
  return set.rest ||
    set.time ||
    (
      getDurationFromRepsSetDataUtil(set.reps)
    )
}

function getDurationSetDataUtil (setData) {
  return setData.reduce(
    (total, set) => total + getSetDurationSetDataUtil(set),
    0
  )
}

function getNonRestSetsCountSetDataUtil (setData) {
  return setData.reduce((total, set) => total +
    (
      isSetRestSetDataUtil(set)
        ? 0
        : 1
    ), 0)
}

function getRepsFromDurationSetDataUtil (duration) {
  return Math.round(duration / SET_DATA_REP_DURATION)
}

export {
  SET_DATA_REP_DURATION,
  getSetDurationSetDataUtil,
  getDurationSetDataUtil,
  getRepsFromDurationSetDataUtil,
  getDurationFromRepsSetDataUtil,
  getNonRestSetsCountSetDataUtil
}

export function getRepsSetUtil (set) {
  return set[SET_DATA_KEY.REPS]
}

export function hasRepsSetUtil (set) {
  return getRepsSetUtil(set) != null
}
